import { Deal } from 'scenes/Dashboard/data/deals/types'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

export const fetchData = createAsyncAction(
  '/scenes/Dashboard/components/OrganizationDetailsModal/FETCH_DATA_BEGIN',
  '/scenes/Dashboard/components/OrganizationDetailsModal/FETCH_DATA_SUCCESS',
  '/scenes/Dashboard/components/OrganizationDetailsModal/FETCH_DATA_FAILURE'
)<
  {
    dealId?: Deal['id']
    organizationId?: Organization['id']
  },
  {
    dealId?: Deal['id']
    organizationId?: Organization['id']
  },
  Error
>()

export const showOrganizationDetails = createAction(
  '/scenes/Dashboard/components/OrganizationDetailsModal/ORGANIZATION_DETAILS_SHOW',
  (resolve) => (data: { dealId?: Deal['id']; organizationId?: Organization['id'] }) => resolve(data)
)

export const showOrganizationDetailsAsAdmin = createAction(
  '/scenes/Dashboard/components/OrganizationDetailsModal/ORGANIZATION_DETAILS_SHOW_AS_ADMIN',
  (resolve) => (data: { dealId?: Deal['id']; organizationId?: Organization['id'] }) => resolve(data)
)

export const hideOrganizationDetails = createAction(
  '/scenes/Dashboard/components/OrganizationDetailsModal/ORGANIZATION_DETAILS_HIDE'
)

export const submitForm = createAsyncAction(
  '/scenes/Dashboard/components/OrganizationDetailsModal/FORM_SUBMIT_BEGIN',
  '/scenes/Dashboard/components/OrganizationDetailsModal/FORM_SUBMIT_SUCCESS',
  '/scenes/Dashboard/components/OrganizationDetailsModal/FORM_SUBMIT_FAILURE'
)<undefined, undefined, undefined>()

export const switchToEditMode = createAction('/scenes/Dashboard/components/OrganizationDetailsModal/EDIT_MODE_SWITCH')

export const switchToViewMode = createAction('/scenes/Dashboard/components/OrganizationDetailsModal/VIEW_MODE_SWITCH')

export type OrganizationDetailsModalAction = ActionType<
  | typeof showOrganizationDetails
  | typeof showOrganizationDetailsAsAdmin
  | typeof hideOrganizationDetails
  | typeof submitForm
  | typeof switchToEditMode
  | typeof switchToViewMode
  | typeof fetchData
>
